import type {Assignment, DCULPath, Student} from "@khan/assignments-types";

/**
 * Maps the assignment data to the mutation variables object.
 *
 * @param {Assignment} assignment The assignment info
 *
 */
// NOTE: Exported for testing purposes
export function assignmentToCommonVariables(assignment: Assignment): any {
    return {
        startDate: assignment.startDate,
        dueDate: assignment.dueDate,
        isDraft: assignment.isDraft,
    };
}

// NOTE: Exported for testing purposes
export function studentsDiff(
    oldStudents: Array<Student>,
    newStudents: Array<Student>,
): {
    added: Array<Student>;
    removed: Array<Student>;
} {
    if (!oldStudents) {
        return {added: newStudents, removed: []};
    }

    const originalStudentsMap = new Map(
        oldStudents.map((student) => [student.kaid, student]),
    );

    const added = newStudents.filter(
        (student) => !originalStudentsMap.has(student.kaid),
    );

    const newStudentsMap = new Map(
        newStudents.map((student) => [student.kaid, student]),
    );

    const removed = oldStudents.filter(
        (student) => !newStudentsMap.has(student.kaid),
    );

    return {added, removed};
}

/**
 * Exported for testing.
 */
export function getQualifiedDescriptor(
    contentDescriptor?: string | null,
    path?: DCULPath | null,
): string | null | undefined {
    if (!path) {
        return contentDescriptor;
    }
    const {domainId, courseId, unitId, lessonId, contentKind, contentId} = path;
    // Create a token with the ids, like: "x111:x222:x333:x444:Video:x555"
    return [domainId, courseId, unitId, lessonId, contentKind, contentId].join(
        ":",
    );
}
